<template>
    <div class="d-flex flex-column flex-fill">
        <form @submit.prevent="onSave" autocomplete="off" data-vv-scope="form">
            <div class="row">
                <div class="col-4">
                    <MaterialSelect
                        :disabled="disabled || saving"
                        class="city-form-group city-bg"
                        id="input-service-type"
                        name="service-type"
                        label="label"
                        :filterable="true"
                        :options="serviceTypes"
                        v-model="form.type"
                        :reduce="option => option.name"
                        v-validate="'required'"
                        :inputClasses="[{'is-invalid': fnHasError('service-type')}]"
                        :error="fnFirstError('service-type')"
                    >
                        {{ serviceTypePlaceholder }}
                    </MaterialSelect>
                </div>
                <div class="col-8">
                    <MaterialInput
                        :disabled="!form.type || disabled || saving"
                        :readonly="disabled"
                        type="text"
                        class="city-form-group city-bg"
                        id="input-service-title"
                        name="service-title"
                        v-model.trim="form.title"
                        v-validate="'required|min:3'"
                        :inputClasses="[{'is-invalid': fnHasError('service-title')}]"
                        :error="fnFirstError('service-title')"
                    >
                        {{ serviceTitlePlaceholder }}
                    </MaterialInput>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <MaterialInput
                        :disabled="!form.type || disabled || saving"
                        :readonly="disabled"
                        type="url"
                        class="city-form-group city-bg"
                        id="input-service-url"
                        name="service-url"
                        v-model.trim="form.url"
                        v-validate="'required|url'"
                        :inputClasses="[{'is-invalid': fnHasError('service-url')}]"
                        :error="fnFirstError('service-url')"
                    >
                        {{ serviceUrlPlaceholder }}
                    </MaterialInput>
                </div>
            </div>
            <div class="row">
                <div class="text-center" :class="[enableDelete ? 'col-sm-4' : 'col-sm-6']">
                    <button :disabled="saving" class="btn btn-main btn-rounded btn-md btn-responsive btn-block min-w-auto" type="submit">
                        {{ submitTitle }}
                    </button>
                </div>
                <div class="col-sm-4 text-center" v-if="enableDelete">
                    <button :disabled="saving" class="btn btn-outline-delete btn-rounded btn-md btn-responsive btn-block min-w-auto" type="button" @click.prevent="onDelete">
                        {{ deleteTitle }}
                    </button>
                </div>
                <div class="text-center" :class="[enableDelete ? 'col-sm-4' : 'col-sm-6']">
                    <button :disabled="saving" class="btn btn-outline-main btn-rounded btn-md btn-block min-w-auto" type="button" @click.prevent="onCancel">
                        {{ cancelTitle }}
                    </button>
                </div>
            </div>
        </form>
        <modal-confirmation ref="modalConfirmation" title=""></modal-confirmation>
    </div>
</template>

<script>
    import GlobalMixin from '@/app/shared/mixins/global';
    import {genId} from '@config/utils'

    export default {
        name: 'CatalogServiceEditor',
        mixins: [
            GlobalMixin,
        ],
        components: {
            ModalConfirmation: () => import(/* webpackChunkName: "modal-confirmation" */ '@/app/shared/components/modals/ModalConfirmation'),
        },
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            saving: {
                type: Boolean,
                default: false,
            },
            serviceTypePlaceholder: {
                type: String,
                default: 'Tipo',
            },
            serviceTitlePlaceholder: {
                type: String,
                default: 'Titulo',
            },
            serviceUrlPlaceholder: {
                type: String,
                default: 'Url',
            },
            serviceTypes: {
                type: Array,
                default: () => [{ name: "csw", label: "CSW" }],
            },
            service: {
                type: Object,
                default: {
                    title: "",
                    type: "wms",
                    url: "",
                    format: "image/png"
                },
            },
            services: {
                type: Array,
            },
            selectedService: {
                type: String,
            },
        },
        data() {
            return {
                form: {
                    id: null,
                    title: "",
                    type: "wms",
                    url: "",
                    format: "image/png",
                    isNew: true,
                },
            }
        },
        mounted() {
            Object.assign(this.form, this.service, {isNew: !this.service.id});
        },
        computed: {
            enableDelete() {
                return this.service ? !this.service.isNew : false;
            },
        },
        methods: {
            onCancel() {
                this.$emit('onChangeCatalogMode', 'view');
            },
            onDelete() {
                this.$refs.modalConfirmation.open((itemId) => {
                        this.$emit('onDeleteService', itemId);
                    },
                    this.form.id,
                    null,
                    'Deseja remover o serviço <strong class=\'font-weight-bold\'>' + this.form.title + '</strong>?'
                );
            },
            onSave() {
                try {
                    this.clearMessages();
                    this.$validator.validateAll('form').then(result => {
                        if(!result){
                            this.showError('global.msg.error.form');
                            return;
                        }

                        this.form.id = this.form.isNew ? this.form.title + genId() : this.form.id;
                        this.$emit('onAddService', this.form);
                    });
                }
                catch(err) {
                    this.showError(err);
                }
                finally {
                }
            },
        }
    }
</script>

<style scoped lang="scss">

</style>